/* eslint-disable */
  // Do not edit this file, it is auto-generated at build time!
  // See scripts/generate-component-factory/index.ts to modify the generation of this file.
  
  import * as CoreAccordion from 'src/components/Core/CoreAccordion';
import * as CoreAlertBanner from 'src/components/Core/CoreAlertBanner';
import * as CoreCallToAction from 'src/components/Core/CoreCallToAction';
import * as CoreCardGrid from 'src/components/Core/CoreCardGrid';
import * as CoreContactCardGrid from 'src/components/Core/CoreContactCardGrid';
import * as ContactCard from 'src/components/Core/CoreContactCardGrid/components/ContactCard';
import * as CoreCrossLinks from 'src/components/Core/CoreCrossLinks';
import * as CoreFlexibleList from 'src/components/Core/CoreFlexibleList';
import * as CoreFullWidthImage from 'src/components/Core/CoreFullWidthImage';
import * as CoreHero from 'src/components/Core/CoreHero';
import * as CoreInfographicGrid from 'src/components/Core/CoreInfographicGrid';
import * as AnimatedStat from 'src/components/Core/CoreInfographicGrid/AnimatedStat';
import * as InfographicCard from 'src/components/Core/CoreInfographicGrid/InfographicCard';
import * as CoreMetadata from 'src/components/Core/CoreMetadata';
import * as CoreNavigationFooter from 'src/components/Core/CoreNavigationFooter';
import * as CoreNavigationHeader from 'src/components/Core/CoreNavigationHeader';
import * as AncillaryNavigation from 'src/components/Core/CoreNavigationHeader/components/AncillaryNavigation';
import * as DesktopPrimaryNav from 'src/components/Core/CoreNavigationHeader/components/DesktopPrimaryNav';
import * as PrimarySubNavigation from 'src/components/Core/CoreNavigationHeader/components/DesktopPrimaryNav/PrimarySubNavigation';
import * as MobilePrimaryNav from 'src/components/Core/CoreNavigationHeader/components/MobilePrimaryNav';
import * as OtherCollegeNavigation from 'src/components/Core/CoreNavigationHeader/components/OtherCollegeNavigation';
import * as CoreRichText from 'src/components/Core/CoreRichText';
import * as AddedPadding from 'src/components/StoryBookDecorators/AddedPadding';
  
  const components = new Map();
  components.set('CoreAccordion', CoreAccordion);
components.set('CoreAlertBanner', CoreAlertBanner);
components.set('CoreCallToAction', CoreCallToAction);
components.set('CoreCardGrid', CoreCardGrid);
components.set('CoreContactCardGrid', CoreContactCardGrid);
components.set('ContactCard', ContactCard);
components.set('CoreCrossLinks', CoreCrossLinks);
components.set('CoreFlexibleList', CoreFlexibleList);
components.set('CoreFullWidthImage', CoreFullWidthImage);
components.set('CoreHero', CoreHero);
components.set('CoreInfographicGrid', CoreInfographicGrid);
components.set('AnimatedStat', AnimatedStat);
components.set('InfographicCard', InfographicCard);
components.set('CoreMetadata', CoreMetadata);
components.set('CoreNavigationFooter', CoreNavigationFooter);
components.set('CoreNavigationHeader', CoreNavigationHeader);
components.set('AncillaryNavigation', AncillaryNavigation);
components.set('DesktopPrimaryNav', DesktopPrimaryNav);
components.set('PrimarySubNavigation', PrimarySubNavigation);
components.set('MobilePrimaryNav', MobilePrimaryNav);
components.set('OtherCollegeNavigation', OtherCollegeNavigation);
components.set('CoreRichText', CoreRichText);
components.set('AddedPadding', AddedPadding);
  
  
  function baseComponentFactory(componentName: string) {
    const component = components.get(componentName);
  
    return component?.Default || component?.default || component;
  }
    
  export function componentFactory(componentName: string) {
    return baseComponentFactory(componentName);
  }
  